/*!
 * [Betbuilder Aggregator API] Panel Module
 * Modul pre UI panel a zobrazovanie BetBuilder výberu
 */

betbuilderAgg.panel = {

    // Renderovanie BetBuilder panela v spodnej časti eventu
    renderPanel: function() {
        try {
            var container = document.getElementById("betbuilder-agg-container");
            
            // Skryť panel ak nie sú žiadne vybraté oddy alebo ak tab nie je aktívny
            if (betbuilderAgg.state.selectedOdds.length === 0 || !betbuilderAgg.state.isTabActive) {
                if (container) {
                    container.style.display = 'none';
                    container.classList.remove("betbuilder-agg__container--active");
                }
                return;
            }

            var singleOdd = betbuilderAgg.state.selectedOdds.length === 1;
            
            var panelHtml = `
                <div id="betbuilder-agg__panel" class="betbuilder-agg__panel ${betbuilderAgg.state.isSuspended ? 'betbuilder-agg__panel--suspended' : ''}">               
                    <span class="betbuilder-agg__logo">
                        <span class="icon icon-betbuilder--agg"></span>
                    </span>
                    <button class="betbuilder-agg__toggle-button" ${!singleOdd && 'onclick="betbuilderAgg.panel.openSelectionModal()"'}>
                        <span class="betbuilder-agg__toggle-button-text">${betbuilderAgg.texts.BetBuilderAggToggleSelection}</span>
                        <span class="betbuilder-agg__toggle-button-count"> ${betbuilderAgg.state.selectedOdds.length}</span>
                        <span class="icon icon-arrow-up betbuilder-agg__toggle-button-icon ${singleOdd && 'betbuilder-agg__toggle-button-icon--hidden'}"></span>
                    </button>
                    <div class="betbuilder-agg__rate-text ${singleOdd && 'betbuilder-agg__rate-text--hidden'}">
                        ${betbuilderAgg.texts.BetBuilderAggTotalRate}
                        <span class="betbuilder-agg__rate">${betbuilderAgg.state.totalOddsValue > 0 ? betbuilderAgg.state.totalOddsValue.toFixed(2) : ' - '}</span>
                    </div>
                    <button class="betbuilder-agg__add-button ${singleOdd && 'betbuilder-agg__add-button--hidden'}" onclick="betbuilderAgg.addToTicket()">
                    ${betbuilderAgg.texts.BetBuilderAggAddToTicket}
                    </button>
                    <div class="betbuilder-agg__single-odd-message ${singleOdd && 'betbuilder-agg__single-odd-message--visible'}">
                        ${betbuilderAgg.texts.BetBuilderAggSingleOddMessage}
                    </div>
                </div>
            `;
            
            // pridanie panela alebo aktualizacia existujuceho panela
            var targetElement = document.querySelector("#event .ui-content");
            if (!targetElement) {
                console.warn('[BetBuilder Panel] Target element #event .ui-content not found');
                return;
            }

            if (!container) {
                container = document.createElement("div");
                container.id = "betbuilder-agg-container";
                container.className = "betbuilder-agg__container";
                targetElement.appendChild(container);
            }
            
            container.innerHTML = panelHtml;
            container.style.display = 'block';
            container.classList.add("betbuilder-agg__container--active");
        } catch (error) {
            console.error('[BetBuilder Panel] Error in renderPanel:', error);
        }
    },

    // Pomocná funkcia pre generovanie HTML zoznamu oddov
    _generateOddsListHtml: function() {
        var htmlOutput = betbuilderAgg.state.selectedOdds.map(function(oddID) {
            var oddElement = document.querySelector(`#chances [id="${oddID}"]`);
            
            // Kontrola či odd existuje a nie je hidden
            if (!oddElement) {
                return null;
            }
            
            var oddVisibility = oddElement.getAttribute('odd-visibility');
            if (oddVisibility === 'hidden') {
                // Odd je neaktívny (closed/inactive), preskočiť v zobrazení
                return null;
            }
            
            var oddName = oddID;
            var oddGroup = 'N/A';
            var oddRate = 'N/A';
            
            var tipName = oddElement.querySelector('#tipName, #tipNameNonGroup');
            if (tipName && tipName.textContent) {
                oddName = tipName.textContent.trim();
            }
            var tipGroup = oddElement.getAttribute('chancetype-name');
            if (tipGroup) {
                oddGroup = tipGroup.trim();
            }
            var rateElement = oddElement.querySelector('#crs');
            if (rateElement && rateElement.textContent) {
                oddRate = rateElement.textContent.trim();
            }
            
            return `
                <div class="betbuilder-agg__odd-item">
                    <span class="betbuilder-agg__odd-item-title">
                        <span class="betbuilder-agg__odd-item-group">${oddGroup}:</span>
                        <span class="betbuilder-agg__odd-item-name">${oddName}</span>
                    </span>
                    <span class="betbuilder-agg__rate betbuilder-agg__rate--modal">${oddRate}</span>
                    <button class="betbuilder-agg__odd-item-remove" onclick="betbuilderAgg.removeOddFromBetBuilder(${oddID})">
                        <span class="icon icon-x-rounded-s betbuilder-agg__odd-item-remove-icon"></span>
                    </button>
                </div>`;
        }).filter(function(html) {
            return html !== null; // Odstráň null hodnoty pre neaktívne/hidden oddy
        }).join("");
        
        return htmlOutput;
    },

    // Otvorenie modal zoznamu vybraných oddov
    openSelectionModal: function() {
        try {
            var modalHtml = `
                <div class="betbuilder-agg__selected-odds-container">
                    <div class="betbuilder-agg__selected-odds-header">
                        <div class="betbuilder-agg__selected-odds-title">${betbuilderAgg.texts.BetBuilderAggSelectionModalTitle}</div>
                        <button class="betbuilder-agg__selected-odds-close" onmousedown="dialog.close('betbuilder-agg__selected-odds-dialog')">
                            <span class="icon icon-x-rounded-l betbuilder-agg__selected-odds-close-icon"></span>
                        </button>
                    </div>
                    <div class="betbuilder-agg__odds-list custom-scrollbar">${betbuilderAgg.panel._generateOddsListHtml()}</div>
                    <div class="betbuilder-agg__no-odds-message">${betbuilderAgg.texts.BetBuilderAggNoSelectedOdds}</div>
                    <div class="betbuilder-agg__selected-odds-footer ${betbuilderAgg.state.selectedOdds.length > 1 ? '' : 'betbuilder-agg__selected-odds-footer--hidden'}">
                        <div class="betbuilder-agg__rate--total">
                            ${betbuilderAgg.texts.BetBuilderAggTotalRate}
                            <span class="betbuilder-agg__rate">${betbuilderAgg.state.totalOddsValue > 0 ? betbuilderAgg.state.totalOddsValue.toFixed(2) : ' - '}</span>
                        </div>
                        <button class="betbuilder-agg__add-button betbuilder-agg__add-button--modal" onmousedown="betbuilderAgg.addToTicket()">${betbuilderAgg.texts.BetBuilderAggAddToTicket}</button>
                    </div>
                </div>
            `;

            // Event listener pre ESC kláves
            var escKeyHandler = function(event) {
                if (event.key === 'Escape' && dialog.isOpen("betbuilder-agg__selected-odds-dialog")) {
                    dialog.close("betbuilder-agg__selected-odds-dialog");
                }
            };

            dialog.open({
                id: "betbuilder-agg__selected-odds-dialog",
                cssClass: "betbuilder-agg__selected-odds-dialog",
                jsEval: false,
                parseJQM: false,
                content: modalHtml,
                shown: function() {
                    // Pridať ESC listener po otvorení modálu
                    document.addEventListener('keydown', escKeyHandler);
                },
                closed: function() {
                    // Odstrániť ESC listener po zatvorení modálu
                    document.removeEventListener('keydown', escKeyHandler);
                }
            });

        } catch (error) {
            console.error('[BetBuilder Panel] Error in openSelectionModal:', error);
            return false;
        }
    },

    // Aktualizácia obsahu modalu s vybranými oddmi
    updateSelectionModalContent: function() {
        try {
            var modal = document.querySelector("#betbuilder-agg__selected-odds-dialog");
            if (!modal) {
                return; // Modal nie je otvorený
            }

            // Aktualizovať zoznam oddov
            var oddsList = modal.querySelector(".betbuilder-agg__odds-list");
            if (oddsList) {
                oddsList.innerHTML = betbuilderAgg.panel._generateOddsListHtml();
            }
            
            // Aktualizovať celkový kurz
            var totalRateElement = modal.querySelector(".betbuilder-agg__rate--total .betbuilder-agg__rate");
            if (totalRateElement) {
                totalRateElement.textContent = betbuilderAgg.state.totalOddsValue > 0 ? betbuilderAgg.state.totalOddsValue.toFixed(2) : ' - ';
            }
            
            // Zobraziť alebo skryť footer podľa počtu vybraných oddov
            var modalFooter = modal.querySelector(".betbuilder-agg__selected-odds-footer");
            if (modalFooter) {
                if (betbuilderAgg.state.selectedOdds.length > 1) {
                    modalFooter.classList.remove('betbuilder-agg__selected-odds-footer--hidden');
                } else {
                    modalFooter.classList.add('betbuilder-agg__selected-odds-footer--hidden');
                }
            }
            
        } catch (error) {
            console.error('[BetBuilder Panel] Error in updateSelectionModalContent:', error);
        }
    }

};
